//--------------------------------------------------------------------------------------------------

  import moment from 'moment'
  import fdb from './firebase_config.js';

  var helpers = {}

//--------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------

  helpers.getItemInitials = function(item) {
    if(!item) return
    if( item.name )           var text = item.name
    if( item.title )          var text = item.title
    if( item.displayName )    var text = item.displayName
    if( item.email )          var text = item.email.substring(0, item.email.indexOf("@"))
    //return text
    if(!text) return
    text = text.toLowerCase()
      .replace("'",'').replace('"','')
      .replace('(','').replace(')','')
      .replace('/','').replace('+','')
      .replace('/','').replace('&','')
      .replace('-','')
      .replace('  ',' ')
    //return text
    if( text.length == 1 ) return text
    if( text.length == 2 ) return text
    var parts = text.split(' ')
    var parts2 = text.split('-')
    var parts2 = text.split('&')
    if( parts2.length > parts.length ) parts = parts2
    if( parts.length == 1 ) return parts[0][0]
    return parts[0][0] + parts[1][0]
  }

//--------------------------------------------------------------------------------------------------

	helpers.roundToDecs = function (input,decs) {
		return +(Math.round(input + 'e+'+decs)  + 'e-'+decs);
	}

//--------------------------------------------------------------------------------------------------

  helpers.getItemColor = function(item) {
    return this.getColorByString( this.getItemInitials(item) )
  }

//--------------------------------------------------------------------------------------------------

  helpers.getColorByString = function(str){
    if(!str) return '#777'
    str = str + str + str + str + str + str + str + str + str + str + str + str + str + str + str // when only one letter, there's not enough colour spread, so this hackfixes that
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xFF;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  }

//--------------------------------------------------------------------------------------------------

  // COPIED TO STORE/MODULES/PROJECTS

  helpers.getProjectBudgetTotal = function(project) {
    if( project.fixed_price ) return parseFloat(project.fixed_price);
    var hour_rate = 790 // default - place this in settings > hour_rates
    if( project.hour_rate ) hour_rate = project.hour_rate
    
    // look at tasks and check them for specific hour_rates

    var spec = this.getProjectAcceptedSpec(project['.key'])
    if( spec ) {
      if( spec.status == 'accepted' ) {
        return this.getSpecTotalBudget(spec)
      }
    }

    return 0
    //return parseFloat( hour_rate * this.getProjectHoursEstimate(project) )

  }

//--------------------------------------------------------------------------------------------------

  helpers.translateProjectStatus = function( status ){
    if( !globals.projectStatuses[ status ] ) return status
    if( !globals.projectStatuses[ status ].title ) return status
    return globals.projectStatuses[ status ].title
  }

//--------------------------------------------------------------------------------------------------

  // MOVED TO VUEX
  helpers.getProjectAcceptedSpec = function(project_key){
    var list = this.$store.state.firebase.specs
    for( var spec_key in list ) {
      if(spec_key == '.key') continue // why, vuexfire?
      var spec = list[spec_key]
      spec['.key'] = spec_key
      if( spec.archived ) continue
      if( spec.project_key == project_key ) return spec
    }
  }

  // MOVED TO VUEX
  helpers.getSpecTotalHours = function(spec){
    var total_hrs = 0
    for( var i in spec.taskcats ) {
      var taskcat = spec.taskcats[i]
      for( var i in taskcat.tasks ) {
        var task = taskcat.tasks[i]
        if( task.optional == false ) continue
        total_hrs += parseFloat(task.hours)
      }
    }
    return total_hrs
  },

  // MOVED TO VUEX
  helpers.getSpecTotalBudget = function(spec){
    return this.getSpecTotalHours(spec) * spec.hour_rate
  },

  //--------------------------------------------------------------------------------------------------

  helpers.getProjectHoursEstimate = function(project){
    if( !project || !project['.key'] )  return 0
    var total_hrs = 0
    var list = this.$store.state.firebase.tasks
    for( var task_key in list ) {
      var task = list[task_key]
      if( task.archived )                                continue
      if( task.project_key != project['.key'] )           continue
      var hrs = parseFloat(task.hours_estimate)
      if( !isNaN(hrs) ) total_hrs += hrs
    }
    return total_hrs
  }

//--------------------------------------------------------------------------------------------------

  helpers.getProjectDonePct = function(project) {
    if( !project || !project['.key'] )  return 0
    if( project.done_pct ) return project.done_pct
    var all_weight = 0
    var done_weight = 0
    var list = this.$store.state.firebase.tasks
    for( var task_key in list ) {
      var task = list[task_key]
      if( task.archived )  continue
      if( task.project_key != project['.key'] )  continue
      if( !task.hours_estimate ) var hrs = 0
      if(  task.hours_estimate ) var hrs = parseFloat(task.hours_estimate)
      all_weight += hrs
      if( task.done ) done_weight += hrs
    }
    if( all_weight == done_weight && done_weight == 0 ) return 0
    if( all_weight == done_weight && done_weight  > 0 ) return 100
    return parseInt( done_weight/all_weight * 100 )
  }

  helpers.getMyUserKeyByUID = function(uid){
    if( !this.users ) return
    var list = this.$store.state.firebase.users
    for( var user_key in list ) {
      var user = list[user_key]      
      if( this.users[i].uid == uid  ) return  this.users[i]['.key']
    }
  }

//--------------------------------------------------------------------------------------------------

  helpers.triggerIconSignal = function(icon){
    eventBus.$emit('triggerIconSignal', icon)
  }

//--------------------------------------------------------------------------------------------------

  function nanToZero(input){
    if( isNaN(input) ) return 0
    return input
  }

//--------------------------------------------------------------------------------------------------

  Number.prototype.formatMoney = function(c, d, t){
    var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  }

//--------------------------------------------------------------------------------------------------

  helpers.outputMoney = function( input, decimals, format ){
    if( !decimals ) decimals = 0
    if( !format ) format = 'a'
    input = parseFloat(input)
    input = nanToZero(input)
    var output = input.formatMoney(decimals,',','.')
    if( format == 'a' ) return output
    if( format == 'b' ) return '' + output + ' kr.'
    if( format == 'c' ) return 'DKK ' + output + ''
    if( format == 'd' ) return output + ',-'
    if( format == 'e' ) return output

  }

//--------------------------------------------------------------------------------------------------

  helpers.getClientProjects = function(client_key, filters){
    var output = []
    var list = this.$store.state.firebase.projects
    for( var project_key in list ) {
      if(project_key == '.key') continue // why, vuexfire?
      var project = list[project_key]
      project['.key'] = project_key

      if( filters ) {
        if( filters.only_active && project.status != 'active' ) continue
        if( filters.only_finished && project.status != 'finished' ) continue
        if( filters.not_archived && project.archived ) continue
      }

      if( project.client_key == client_key ) output.push(project)
    }
    return output
  }

//--------------------------------------------------------------------------------------------------

  helpers.clientTotalEarning = function(client_key){
    var projects = this.getClientProjects(client_key)
    var total = 0
    for( var i = 0; i < projects.length; i++ ) {
      var project = projects[i]
      if(project.archived) continue
      total += this.getProjectBudgetTotal(project)
    }
    return this.outputMoney(total,'a')
    //return total
  }

//--------------------------------------------------------------------------------------------------

	//@TODO: UNUSED FOR NOW?

  helpers.readTimebookedHours = function(input) {
    var hrs = 0
    var list = this.$store.state.firebase.timebookings    
    if( !list ) return hrs
    for( var timebookings_key in list ) {
      var timebooking = list[timebookings_key]

      if( input.timeframe == 'today' ) {
        if( moment( timebooking.date ).isAfter( moment(), 'seconds' ) ) continue
        if( moment( timebooking.date ).isBefore( moment(), 'seconds' ) ) continue
      }

      if( input.user_key && timebooking.user_key != input.user_key ) continue
      if( input.project_key && timebooking.project_key != input.project_key ) continue
      if( input.client_key && timebooking.client_key != input.client_key ) continue
      if( input.task_key && timebooking.task_key != input.task_key ) continue
      hrs += timebooking.hours
    }
    return hrs
  }

//--------------------------------------------------------------------------------------------------
  
// kill this shit

  helpers.readTimeloggedHours = function(input) {
    var hrs = 0
    
    var list = this.$store.state.firebase.timelogs
    if( !list ) return hrs
    
    if( input.timeframe == 'today' ) {
      var now_timestamp_from = moment().startOf('day').unix()
      var now_timestamp_to = moment().endOf('day').unix()
    }

    for( var timelog_key in list ) {
      if(timelog_key == '.key') continue // why, vuexfire?

      var timelog = list[timelog_key]      
      timelog['.key'] = timelog_key

      if( !timelog.date_timestamp ) {
        console.log('timelog: converting time format (helpers)')
        var timestamp = moment(timelog.date).unix()
        this.$set( this.$store.state.firebase.timelogs[timelog_key], 'date_timestamp', timestamp )
        
        helpers.log('no timestamp set for timelog - setting it now')

        //timelog[i].date_timestamp = moment(timelog.date).unix()
        var timelog = this.$store.state.firebase.timelogs[timelog_key]
        timelog['.key'] = timelog_key
      }

      if( input.user_key && timelog.user_key != input.user_key ) continue
      if( input.project_key && timelog.project_key != input.project_key ) continue
      if( input.client_key && timelog.client_key != input.client_key ) continue
      if( input.task_key && timelog.task_key != input.task_key ) continue

      if( input.timeframe == 'today' ) {
        if( timelog.date_timestamp < now_timestamp_from ) continue
        if( timelog.date_timestamp > now_timestamp_to ) continue
      }
      
      hrs += timelog.hours
    }
    return hrs
  }


//--------------------------------------------------------------------------------------------------

    helpers.getLastTimelogs = function(number){
      var output = []
        
      var list = this.$store.state.firebase.timelogs
      if( !list ) return output

      var newestTimelogs = _.cloneDeep(list)

      if( !newestTimelogs ) return

      console.log(newestTimelogs)

      newestTimelogs.sort(function(a,b){
        return ( moment(b.date).unix() > moment(a.date).unix() )
      })

      return newestTimelogs.slice( 0, number )
    }
    
//--------------------------------------------------------------------------------------------------

	// @todo: unused for now?

	helpers.getFilteredTimebookings = function(filters){
	  var items = []
	  //console.log(this.timelogs)
	  //return items
	  //return this.timelogs
    if( !this.timebookings ) return items
	  for( var i = 0; i < this.timebookings.length; i++ ) {
  		var timebooking = this.timebookings[i]
  		if( timebooking.archived ) continue
  		if( filters.user_key != undefined && filters.user_key != 'undefined' ) {
  		  if( filters.user_key != timebooking.user_key ) continue
  		}
  		if( filters.project_key != undefined && filters.project_key != 'undefined' ) {
  		  if( filters.project_key != timebooking.project_key ) continue
  		}
  		if( filters.client_key != undefined && filters.client_key != 'undefined' ) {
  		  var timelog_client = this.getClientByProjectKey(timebooking.project_key)
  		  if( !timelog_client ) continue
  		  //console.log(timelog_client)
  		  if( filters.client_key != timelog_client['.key'] ) continue
  		}

  		if( filters.date_from && moment( timebooking.date ).isBefore( filters.date_from, 'seconds' ) ) continue
  		if( filters.date_to && moment( timebooking.date ).isAfter( filters.date_to, 'seconds' ) ) continue

  		items.push(timebooking)
	  }

	  // sorting
	  items.sort(function(a,b){
		  return moment(b.date) - moment(a.date)
	  })

	  return items
	}

//--------------------------------------------------------------------------------------------------

    helpers.delete_timelog = function(timelog){
      var sure = confirm('Er du sikker?')
      if( !sure ) return
      var id = timelog['.key']
      fdb.ref('timelogs').child( id ).remove()
      eventBus.$emit('toast', {text:'Timelog deleted'})
    }

//--------------------------------------------------------------------------------------------------

    helpers.getClientKeyFromTimelog = function(timelog) {
      //console.log( this.$store.state.firebase.clients )
      var project = this.$store.state.firebase.projects[ timelog.project_key ]
      if(!project) return
      return project.client_key
    }

    helpers.getClientFromTimelog = function(timelog) {
      var client_key = this.getClientKeyFromTimelog(timelog)
      return this.$store.state.firebase.clients[client_key]
    }

//--------------------------------------------------------------------------------------------------

    helpers.translateWorktype = function(worktype){
      if( !worktype || worktype == 'undefined' ) return 'Andet'
      for( var i = 0; i < globals.worktypes.length; i++ ) {
        if( worktype == globals.worktypes[i].value ) return globals.worktypes[i].title
      }
      return worktype
    }

//--------------------------------------------------------------------------------------------------

    helpers.getProject = function(key){
      var project = {}
      if( !this.$store.state.firebase.projects ) return project
      if( this.$store.state.firebase.projects[key] ) project = this.$store.state.firebase.projects[key]
      return project
    }

//--------------------------------------------------------------------------------------------------

    helpers.getClient = function(project_key){
      var client = {}
      var project = this.getProject(project_key)
      if( project['client_key'] && this.$store.state.firebase.clients[project['client_key']] ) {
        client = this.$store.state.firebase.clients[project['client_key']]
        client['.key'] = project['client_key']
      }
      return client
    }

//--------------------------------------------------------------------------------------------------

    helpers.getClientByProjectKey = function(project_key){
      //console.log(123)
      //console.log(this.$store.state.firebase.projects)
      //console.log(this.$store.state.firebase.clients)
      //if( !this.$store.state.firebase.projects ) return
      //if( !this.$store.state.firebase.clients ) return
      //console.log(project_key)
      var project = this.$store.state.firebase.projects[project_key]
      //console.log(project)
      if( !project ) return
      var client = this.$store.state.firebase.clients[project.client_key]
      if( !client ) return
      return client
    }

//--------------------------------------------------------------------------------------------------
/*
getMonthStats( activeMonth, activeYear ){
  if( activeMonth == undefined ) activeMonth = this.activeMonth
  if( activeYear == undefined ) activeYear = this.activeYear
  var output = {
    payments_total: 0,
  }
  var payments = this.getMonthPayments( activeMonth, activeYear )
  for( var i in payments ) {
    var payment = payments[i]
    output.payments_total += parseFloat(payment.amount_dkk_ex_vat)
  }
  return output
},
*/

  helpers.getProjectEconomyFigures = function( year, month, project_key ){

    if( month == undefined )  month = this.activeMonth
    if( year == undefined )   year = this.activeYear
    var output = {
      budgetted: 0,
      invoiced: 0,
      paid: 0,
    }
    var list = this.$store.state.firebase.payments
    for( var payment_key in list ) {
      var payment = list[payment_key]
      if( project_key && payment.project_key != project_key ) continue
      if( !moment( payment.due_date ).isSame(year+'-'+month+'-15') ) continue
      output.budgetted        += parseFloat(payment.amount_dkk_ex_vat)
      if( payment.invoiced )  output.invoiced += parseFloat(payment.amount_dkk_ex_vat)
      if( payment.paid )      output.paid     += parseFloat(payment.amount_dkk_ex_vat)
    }
    return output
  }

//--------------------------------------------------------------------------------------------------

  helpers.fixFirebaseKey = function(obj) {
    obj.key = obj['.key']
    delete obj['.key']
    return obj
  }

  // the bad news is that this func might be heavy and will mutate the object, creating .key and ['.key'] on it
  // if we dont use this, however, we wll not have the key present
  helpers.keyedObjectToArray = function(keyedObject) {
    var outputArray = []
    for( let key in keyedObject ) {
      if(key == '.key') continue // why, vuexfire?
      let entry = keyedObject[key]            
      entry.mutated_by_keyedObjectToArray = true
      entry.key = key
      entry['.key'] = key // TODO: fix this old shit remnant
      outputArray.push( entry )
    }
    return outputArray
  }

//--------------------------------------------------------------------------------------------------

  helpers.getUserbyUID = function(uid){

    var output = {}
    if(!uid) return output
    
    var list = this.$store.state.firebase.users
    if(!list) return output
    
    for( var user_key in list ) {
      var this_user = list[user_key]
      if( this_user == 'users' ) continue
      this_user['.key'] = user_key
      if( this_user.uid == uid ) output = this_user
    }
    return output
  }

//--------------------------------------------------------------------------------------------------

  helpers.stringPad = function(str, length, padChar) {
    while ( str.length < length )
        str = padChar + str
    return str
  }

//--------------------------------------------------------------------------------------------------

  helpers.colorNameGetHex = function(colorname) {
    var colors = {'aliceblue':'#f0f8ff','antiquewhite':'#faebd7','aqua':'#00ffff','aquamarine':'#7fffd4','azure':'#f0ffff','beige':'#f5f5dc','bisque':'#ffe4c4','black':'#000000','blanchedalmond':'#ffebcd','blue':'#0000ff','blueviolet':'#8a2be2','brown':'#a52a2a','burlywood':'#deb887', 'cadetblue':'#5f9ea0','chartreuse':'#7fff00','chocolate':'#d2691e','coral':'#ff7f50','cornflowerblue':'#6495ed','cornsilk':'#fff8dc','crimson':'#dc143c','cyan':'#00ffff','darkblue':'#00008b','darkcyan':'#008b8b','darkgoldenrod':'#b8860b','darkgray':'#a9a9a9','darkgreen':'#006400','darkkhaki':'#bdb76b','darkmagenta':'#8b008b','darkolivegreen':'#556b2f', 'darkorange':'#ff8c00','darkorchid':'#9932cc','darkred':'#8b0000','darksalmon':'#e9967a','darkseagreen':'#8fbc8f','darkslateblue':'#483d8b','darkslategray':'#2f4f4f','darkturquoise':'#00ced1', 'darkviolet':'#9400d3','deeppink':'#ff1493','deepskyblue':'#00bfff','dimgray':'#696969','dodgerblue':'#1e90ff', 'firebrick':'#b22222','floralwhite':'#fffaf0','forestgreen':'#228b22','fuchsia':'#ff00ff', 'gainsboro':'#dcdcdc','ghostwhite':'#f8f8ff','gold':'#ffd700','goldenrod':'#daa520','gray':'#808080','green':'#008000','greenyellow':'#adff2f', 'honeydew':'#f0fff0','hotpink':'#ff69b4', 'indianred ':'#cd5c5c','indigo':'#4b0082','ivory':'#fffff0','khaki':'#f0e68c', 'lavender':'#e6e6fa','lavenderblush':'#fff0f5','lawngreen':'#7cfc00','lemonchiffon':'#fffacd','lightblue':'#add8e6','lightcoral':'#f08080','lightcyan':'#e0ffff','lightgoldenrodyellow':'#fafad2', 'lightgrey':'#d3d3d3','lightgreen':'#90ee90','lightpink':'#ffb6c1','lightsalmon':'#ffa07a','lightseagreen':'#20b2aa','lightskyblue':'#87cefa','lightslategray':'#778899','lightsteelblue':'#b0c4de', 'lightyellow':'#ffffe0','lime':'#00ff00','limegreen':'#32cd32','linen':'#faf0e6', 'magenta':'#ff00ff','maroon':'#800000','mediumaquamarine':'#66cdaa','mediumblue':'#0000cd','mediumorchid':'#ba55d3','mediumpurple':'#9370d8','mediumseagreen':'#3cb371','mediumslateblue':'#7b68ee', 'mediumspringgreen':'#00fa9a','mediumturquoise':'#48d1cc','mediumvioletred':'#c71585','midnightblue':'#191970','mintcream':'#f5fffa','mistyrose':'#ffe4e1','moccasin':'#ffe4b5', 'navajowhite':'#ffdead','navy':'#000080', 'oldlace':'#fdf5e6','olive':'#808000','olivedrab':'#6b8e23','orange':'#ffa500','orangered':'#ff4500','orchid':'#da70d6', 'palegoldenrod':'#eee8aa','palegreen':'#98fb98','paleturquoise':'#afeeee','palevioletred':'#d87093','papayawhip':'#ffefd5','peachpuff':'#ffdab9','peru':'#cd853f','pink':'#ffc0cb','plum':'#dda0dd','powderblue':'#b0e0e6','purple':'#800080', 'rebeccapurple':'#663399','red':'#ff0000','rosybrown':'#bc8f8f','royalblue':'#4169e1', 'saddlebrown':'#8b4513','salmon':'#fa8072','sandybrown':'#f4a460','seagreen':'#2e8b57','seashell':'#fff5ee','sienna':'#a0522d','silver':'#c0c0c0','skyblue':'#87ceeb','slateblue':'#6a5acd','slategray':'#708090','snow':'#fffafa','springgreen':'#00ff7f','steelblue':'#4682b4', 'tan':'#d2b48c','teal':'#008080','thistle':'#d8bfd8','tomato':'#ff6347','turquoise':'#40e0d0', 'violet':'#ee82ee', 'wheat':'#f5deb3','white':'#ffffff','whitesmoke':'#f5f5f5', 'yellow':'#ffff00','yellowgreen':'#9acd32'};
   if(typeof colors[colorname.toLowerCase()] != 'undefined') return colors[colorname.toLowerCase()]
   return false
}

//--------------------------------------------------------------------------------------------------

  helpers.idealTextColor = function(bgColor) {
    if( bgColor == 'black' ) return '#ffffff'
    if( bgColor == 'white' ) return '#000000'
    if( bgColor == 'grey' ) return '#000000'
    var hexColor = this.colorNameGetHex(bgColor)
    if(hexColor) bgColor = hexColor
    var nThreshold = 105;
    var components = this.getRGBComponents(bgColor);
    var bgDelta = (components.R * 0.299) + (components.G * 0.587) + (components.B * 0.114);

    return ((255 - bgDelta) < nThreshold) ? "#000000" : "#ffffff";
  }

//--------------------------------------------------------------------------------------------------

  helpers.getRGBComponents = function(color) {

      var r = color.substring(1, 3);
      var g = color.substring(3, 5);
      var b = color.substring(5, 7);

      return {
         R: parseInt(r, 16),
         G: parseInt(g, 16),
         B: parseInt(b, 16)
      };
  }

//--------------------------------------------------------------------------------------------------

  helpers.img_loaded = function( imgurl, callback ){ 
    var img = new Image()
    img.addEventListener('load', () => { if(callback) callback() })
    img.src = imgurl
  }

//--------------------------------------------------------------------------------------------------

  helpers.moment_enumerateDaysBetweenDates = function(startDate, endDate) {
    var dates = [];

    var currDate = moment(startDate).startOf('day');
    var lastDate = moment(endDate).startOf('day');

    while(currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone())
    }

    return dates;
  }

//--------------------------------------------------------------------------------------------------

  helpers.log = function( input ){
    
    if( !window['$kia'] ) return

    if( typeof input != 'object' ) {
      console.warn('%c  Kia  %c  '+input+'  ', 'background: #333; color: #fff; border-radius: 4px 0 0 4px;', 'background: #DDD; color: #000; border-radius: 0 4px 4px 0;')
      //console.warn( '%c >> App log: '+input, 'color: #00883F;' )      
    }
    
    if( typeof input == 'object' ) {
      var label = 'KIA LOGGING ITEM:'
      console.group(label)
        //console.warn('%c  Kia  %c  Logging item below', 'background: #333; color: #fff; border-radius: 4px 0 0 4px;', 'background: #DDD; color: #000; border-radius: 0 4px 4px 0;')
        console.warn(input)
      console.groupEnd(label)
    }

    //console.trace()

  }

//--------------------------------------------------------------------------------------------------

  export default helpers



// WEBPACK FOOTER //
// ./src/helpers.js